import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-19559c73"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "reference-item" }
const _hoisted_2 = {
  key: 0,
  class: "referenceTitle"
}
const _hoisted_3 = { class: "referenceWrapper" }
const _hoisted_4 = { class: "indexWrapper" }
const _hoisted_5 = { class: "urlWrapper" }
const _hoisted_6 = ["href"]

import { PropType } from 'vue'
import { Reference } from '../../typings'

// message：接受消息对象，展示消息内容和头像，并且根据角色调整消息位置。

export default /*#__PURE__*/_defineComponent({
  __name: 'ReferenceItem',
  props: {
  reference: { type: Object as PropType<Reference>, required: true },
  index: { type:Number  ,required: true},
},
  setup(__props) {

const props = __props


const openInNewTab = (event: MouseEvent) =>
{
    event.preventDefault(); // 阻止默认的 a 标签行为
    window.open(props.reference.url, '_blank'); // 在新窗口/标签页打开链接
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (0 == __props.index)
      ? (_openBlock(), _createElementBlock("span", _hoisted_2, _toDisplayString(_ctx.$t("messageRow.reference")), 1))
      : _createCommentVNode("", true),
    _createElementVNode("div", _hoisted_3, [
      _createElementVNode("div", _hoisted_4, _toDisplayString((__props.index+1) + "."), 1),
      _createElementVNode("div", _hoisted_5, [
        _createElementVNode("a", {
          class: "url",
          href: __props.reference.url,
          onClick: openInNewTab
        }, _toDisplayString(__props.reference.description), 9, _hoisted_6)
      ])
    ])
  ]))
}
}

})